/**
 * Single source of truth for the dictation / full-encounter-recording cutoff.
 *
 * A recording at or above this many seconds is treated as a full encounter
 * recording (its clock seeds the encounter start/end times and it's titled
 * "Encounter Recording"); anything shorter is a dictation (titled
 * "Dictation N", does not move the encounter clock).
 *
 * GDN-2017: this constant previously existed as three independent literals —
 * 120s in the v1 recording widget and v2 encounter view, but 60s in the
 * navigation workflow guard — so a ~90s recording was classified as a full
 * recording on the guard's exit path but as a dictation everywhere else.
 * Importing this one value (and {@link isFullEncounterRecording}) keeps every
 * exit path in agreement.
 */
export const DICTATION_THRESHOLD_SECONDS = 120;

/** True when a recording of `elapsedSeconds` is a full encounter recording. */
export const isFullEncounterRecording = (elapsedSeconds: number): boolean =>
  elapsedSeconds >= DICTATION_THRESHOLD_SECONDS;
